<template>
  <div>
    <h1 class="page-header">{{ $t('holidayrule.holidayRule') }}</h1>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-md-4 col-sm-12 d-flex">
            <select
              class="form-control m-r-10 text-center"
              v-model="model.sub_day1"
            >
              <option value="" selected>{{
                $t('holidayrule.substituteFirstDay')
              }}</option>
              <option
                v-for="(substituteDay, index) in substituteDays"
                :key="index"
                :value="substituteDay.day"
              >
                {{ substituteDay.day }}
              </option>
            </select>
            <select class="form-control text-center" v-model="model.sub_day2">
              <option value="" selected>{{
                $t('holidayrule.substituteSecondDay')
              }}</option>
              <option
                v-for="(substituteDay, index) in substituteDays"
                :key="index"
                :value="substituteDay.day"
              >
                {{ substituteDay.day }}
              </option>
            </select>
          </div>
          <div class="col-sm-12"></div>
        </div>
      </ts-card-wrapper>
      <div id="container-table">
        <table class="table table-hover ui-table">
          <thead>
            <tr>
              <th>{{ $t('holidayrule.holidayKhmer') }}</th>
              <th>{{ $t('holidayrule.holidayEnglish') }}</th>
              <th style="width:10%">{{ $t('holidayrule.dayOfMonth') }}</th>
              <th style="width:10%">{{ $t('holidayrule.month') }}</th>
              <th style="width:3%" class="text-center">
                <a href="#" @click.prevent="addNewRow">
                  <i class="fa fa-plus"></i>
                </a>
              </th>
            </tr>
            <tr v-if="loading == true">
              <th colspan="5" class="table-data-loading">
                <div class="table-data-loading__sliders">
                  <div class="table-data-loading__line"></div>
                  <div
                    class="table-data-loading__subline table-data-loading__subline__inc"
                  ></div>
                  <div
                    class="table-data-loading__subline table-data-loading__subline__dec"
                  ></div>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(list, index) in model.hol_list" :key="index">
              <td>
                <input
                  v-model="list.hol_name_kh"
                  type="text"
                  class="form-control only-border-bottom kh-font"
                />
              </td>
              <td>
                <input
                  v-model="list.hol_name_en"
                  type="text"
                  class="form-control only-border-bottom"
                  :class="{
                    'is-invalid': errors.has(
                      'hol_list.' + index + '.hol_name_en'
                    )
                  }"
                />
              </td>
              <td>
                <select
                  class="form-control only-border-bottom"
                  v-model="list.hol_day"
                  :class="{
                    'is-invalid': errors.has('hol_list.' + index + '.hol_day')
                  }"
                >
                  <option value="">--select--</option>
                  <option
                    v-for="dayOfMonth in 31"
                    :key="dayOfMonth"
                    :value="dayOfMonth"
                    >{{ dayOfMonth }}</option
                  >
                </select>
              </td>
              <td>
                <select
                  class="form-control only-border-bottom"
                  v-model="list.hol_month"
                  :class="{
                    'is-invalid': errors.has('hol_list.' + index + '.hol_month')
                  }"
                >
                  <option value="">--select month--</option>
                  <option
                    v-for="(month, index) in months"
                    :key="index"
                    :value="month.value"
                  >
                    {{ month.name }}
                  </option>
                </select>
              </td>
              <td class="text-center" valign="middle">
                <a
                  href="#"
                  class="text-danger"
                  @click.prevent="removeRow(list)"
                >
                  <i class="fa fa-trash mt-2"></i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-md-12 text-right">
            <ts-button
              v-if="recordExist == false && model.hol_list.length > 0"
              @click.prevent="store"
              class="btn-primary btn mt-2"
              :waiting="waiting"
            >
              Save
            </ts-button>
            <ts-button
              v-if="recordExist"
              @click.prevent="update"
              class="btn-primary btn mt-2"
              :waiting="waiting"
            >
              Update
            </ts-button>
          </div>
        </div>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'holiday-rule',
  data() {
    return {
      loading: false,
      waiting: false,
      recordExist: false,
      errors: new Errors(),
      model: {
        sub_day1: '',
        sub_day2: '',
        hol_list: []
      },
      substituteDays: [
        { day: 'Monday' },
        { day: 'Tuesday' },
        { day: 'Wednesday' },
        { day: 'Thursday' },
        { day: 'Friday' },
        { day: 'Saturday' },
        { day: 'Sunday' }
      ],
      months: [
        {
          value: 1,
          name: 'January'
        },
        {
          value: 2,
          name: 'February'
        },
        {
          value: 3,
          name: 'March'
        },
        {
          value: 4,
          name: 'April'
        },
        {
          value: 5,
          name: 'May'
        },
        {
          value: 6,
          name: 'June'
        },
        {
          value: 7,
          name: 'July'
        },
        {
          value: 8,
          name: 'August'
        },
        {
          value: 9,
          name: 'September'
        },
        {
          value: 10,
          name: 'October'
        },
        {
          value: 11,
          name: 'November'
        },
        {
          value: 12,
          name: 'December'
        }
      ],
      newRow: {
        hol_month: '',
        hol_day: '',
        hol_name_kh: '',
        hol_name_en: ''
      }
    }
  },
  created() {
    this.fetchData()
    this.setSubstituteValue()
  },
  computed: {
    ...mapState('holidayRule', ['substitutes', 'holiday_rule_resources'])
  },
  methods: {
    fetchData(attribute) {
      this.loading = true
      this.$store
        .dispatch('holidayRule/fetch')
        .then(response => {
          if (response.length > 0) {
            this.model.hol_list = _.clone(response)
            this.recordExist = true
          }
          this.loading = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = false
        })
    },
    addNewRow() {
      this.model.hol_list.push(_.clone(this.newRow))
    },
    removeRow(record) {
      this.model.hol_list.splice(this.model.hol_list.indexOf(record), 1)
    },

    store() {
      ;(this.errors = new Errors()), (this.waiting = true)
      this.$store
        .dispatch('holidayRule/store', this.model)
        .then(response => {
          this.waiting = false
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch(error => {
          this.waiting = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    },

    update() {
      ;(this.errors = new Errors()), (this.waiting = true)
      this.$store
        .dispatch('holidayRule/update', this.model)
        .then(response => {
          this.waiting = false
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch(error => {
          this.waiting = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    },

    setSubstituteValue() {
      if (!_.isEmpty(this.substitutes)) {
        this.model.sub_day1 = this.substitutes.sub_day1
          ? this.substitutes.sub_day1
          : ''
        this.model.sub_day2 = this.substitutes.sub_day2
          ? this.substitutes.sub_day2
          : ''
      }
    }
  }
}
</script>

<style lang="css" scoped>
#container-table {
	max-height: 67vh;
	overflow-y:scroll;
	overflow-x: hidden;
	scrollbar-width: none;
   -ms-overflow-style: none;
}
::-webkit-scrollbar {
		width: 3px;  /* Remove scrollbar space */
		background: transparent;  /* Optional: just make scrollbar invisible */
}
/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
		background: rgb(194, 194, 194);
}
.table > thead > tr > th {
	  position: sticky;
		position: -webkit-sticky;
		top: 0;
		z-index: 999;
}
.table > tbody > tr > td{
	padding-top: 5px !important;
	padding-bottom: 5px !important;
	border: none !important
}
.only-border-bottom {
	border-top: none;
	border-left: none;
	border-right: none;
}
</style>
